import React, { useContext, useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  TextField,
} from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { requestAxios, ComboBox, infoSource } from "../../../util/util";
import { CheckBox, InputForm } from "../../Common/Controls/Controls";
import ModalEtapa1 from "./EtapaProcesal/ModalEtapa1";
import ModalNuevaEtapa from "./EtapaProcesal/ModalNuevaEtapa";
import ItemEtapaProcesal from "./ItemEtapaProcesal";
import AppContext from "../../../Context/AppContext";
import { KTSVG } from "../../../helpers";
import "./ModalAdicionDemanda.css";

const ModalAdicion = ({ show, setShow, setCurrentRow, currentRow,loadInfoParent }) => {
  const { checkUserSession, contextAcreditado, changeLoading } =
    useContext(AppContext);
  const [cmbJuzgados, setCmbJuzgados] = useState([]);
  const [cmbTipoJuicio, setCmbTipoJuicio] = useState([]);
  const [etapasProcesal, setEtapasProcesal] = useState([]);
  const [showModalEtapa, setShowModalEtapa] = useState(false);
  const [showNuevaModalEtapa, setShowNuevaModalEtapa] = useState(false);
  const [validated, setValidated] = useState(false);
  const [currentEtapa, setCurrentEtapa] = useState({});
  const infoUs = checkUserSession();
  const acreditadoInfo = contextAcreditado.getInfoAcreditado();

  useEffect(() => {
    loadInfo();
  }, []);

  async function loadInfo() {
    var listJuzgados = await ComboBox.cmbJuzgado(infoUs);
    var listTipoJuicio = await ComboBox.cmbTipoJuicio(infoUs);
    var listEtapaProcesal = await infoSource.Demandas.EtapasDemandas(
      infoUs,
      currentRow.AsigDemandaId
    );
    debugger
    const Acre=  await infoSource.Acreditados.GetSingleAcreditado(infoUs,currentRow.AcreditadoId);
    contextAcreditado.setinfoAcreditado(Acre)
    setCmbJuzgados(listJuzgados);
    setCmbTipoJuicio(listTipoJuicio);
    setEtapasProcesal(listEtapaProcesal);
  }

  function setDataRow(field, data) {
    let newRow = { ...currentRow };
    newRow[field] = data;
    setCurrentRow(newRow);
  }
  async function saveData() {
    changeLoading(true);
    const MySwal = withReactContent(Swal);
    const folioVa = currentRow.AsigDfolioDemanda.split("/");
    let errorFolio = false;
    if (folioVa.length !== 2) {
      errorFolio = true;
    } else if (folioVa[0].length!==4 && folioVa[0].length!==4) {
      errorFolio = true;
    }

    if (errorFolio == true) {
      changeLoading(false);
      await MySwal.fire({
        title: <strong>Error</strong>,
        html: (
          <i>
            El Campo <b>Exp. Judicial</b> no cumple con el formato
            solicitado.<b>(####/####)</b>
          </i>
        ),
        icon: "error",
      });
      return false;
    }
    currentRow.JuzgadoId = Number(currentRow.JuzgadoId);
    currentRow.TipoJuicioId = Number(currentRow.TipoJuicioId);
    currentRow.AcreditadoId = Number(currentRow.AcreditadoId);
    const { error, data } = await requestAxios({
      url: `Demandas/${
        currentRow.AsigDemandaId !== 0 ? "UDemanda" : "IDemanda"
      }`,
      method: currentRow.AsigDemandaId !== 0 ? "put" : "post",
      token: infoUs.bearer_token,
      data: currentRow,
    });
    if (error === "") {
      changeLoading(false);
      await MySwal.fire({
        title: <strong>Hecho!</strong>,
        html: <i>Guardado con éxito!</i>,
        icon: "success",
      });
      setShow(false)
      loadInfoParent();
    } else {
      alert("Error, try again");
    }
    changeLoading(false);
  }
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    if (form.checkValidity() === true) {
      saveData();
    }
  };
  async function selectModal(visibility, currentEtapax) {
    const etapa1 = etapasProcesal.find((x) => x.EtaClave === "1000").etapaInfo;
    if (etapa1 == null && currentEtapax.EtaClave !== "1000") {
      const MySwal = withReactContent(Swal);
      await MySwal.fire({
        title: <strong>Error!</strong>,
        html: <i>Es necesario capturar la estapa 1 para continuar</i>,
        icon: "error",
      });
      return false;
    }
    if (currentEtapax.etapaInfo != null) {
      setShowModalEtapa(visibility);
    } else {
      setShowNuevaModalEtapa(visibility);
    }
  }
  function reloadModal(){
    setShow(false)
    loadInfoParent();
  }
  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        className={`ModalDemandas ${
          (showModalEtapa || showNuevaModalEtapa) && "ModalDemandasHide"
        }`}
        dialogClassName="modal-90wDemandas"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="AcreditadoDetalleModalTitle">
            Registro del seguimiento a la Demanda del Acreditado
            <h2>Rellene los campos y pulse guardar</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modalAdicion__nombrecontainer">
            <div>
              Num. Expediente: <h1>{acreditadoInfo.AcreditadoId}</h1>
            </div>
            <div>
              Nombre: <h1>{acreditadoInfo.Nombreac}</h1>
            </div>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="modalAdicionDemanda__bodycontainer">
              <div className="expJudicial__container">
                <TextField
                  id="outlined-basic"
                  label="Exp. Judicial"
                  variant="outlined"
                  value={currentRow["AsigDfolioDemanda"]}
                  onChange={(input) =>
                    setDataRow("AsigDfolioDemanda", input.target.value)
                  }
                />
                <h1>Ejemplo: 0125/2021</h1>
              </div>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Núm. de Juzgado
                </InputLabel>
                <Select
                  required
                  className="cmbTipoGestion"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={
                    <div className="cmbTipoGestionTitle">Núm. de Juzgado</div>
                  }
                  onClick={(input) =>
                    setDataRow("JuzgadoId", input.target.dataset.value)
                  }
                  value={currentRow.JuzgadoId}
                >
                  {cmbJuzgados.map((item) => (
                    <MenuItem className="cmbTipoGestion_Item" value={item.Id}>
                      {item.Text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Tipo de juicio
                </InputLabel>
                <Select
                  required
                  className="cmbTipoGestion"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={
                    <div className="cmbTipoGestionTitle">Tipo de juicio</div>
                  }
                  onClick={(input) =>
                    setDataRow("TipoJuicioId", input.target.dataset.value)
                  }
                  value={currentRow.TipoJuicioId}
                >
                  {cmbTipoJuicio.map((item) => (
                    <MenuItem className="cmbTipoGestion_Item" value={item.Id}>
                      {item.Text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                id="outlined-basic"
                label="Comentario"
                variant="outlined"
                value={currentRow["AsigDComentarios"]}
                multiline
                rows={2}
                maxRows={4}
                onChange={(input) =>
                  setDataRow("AsigDComentarios", input.target.value)
                }
              />
            </div>
            {currentRow.AsigDemandaId == 0 ? (
              <button className="btnNuevaGestion">Guardar</button>
            ) : (
              <div className="modalAdicionDemanda__bodycontainer2">
                <h1>Etapa Procesal</h1>
                <h2>
                  Para agregar una etapa procesal pulse el botón de "agregar"
                  para ingresar los datos correspondientes, pulse el icono de
                  binoculares para visualizar el detalle y el icono de lápiz
                  para editar o actualizar
                </h2>
                <div className="etapasProcesal__container">
                  {etapasProcesal.map((item) => (
                    <ItemEtapaProcesal
                      titulo={item.EtaDescripcion}
                      fecha={
                        item.etapaInfo != null
                          ? item.etapaInfo.AsigDefechaInicio
                          : ""
                      }
                      setShowModalEtapa={selectModal}
                      currentEtapa={item}
                      setCurrentEtapa={setCurrentEtapa}
                    />
                  ))}
                </div>
                <div className="modalAdicion__buttoncontainer">
                  <button
                    className="modalAdicion__btnCancelar"
                    type="button"
                    onClick={() => setShow(false)}
                  >
                    Cancelar
                  </button>
                  <button
                    className="modalAdicion__btnRegistrar"
                    onClick={() => console.log(currentRow)}
                    type="submit"
                  >
                    Registrar
                  </button>
                </div>
              </div>
            )}
          </Form>
        </Modal.Body>
      </Modal>
      {showModalEtapa && (
        <ModalEtapa1
          show={showModalEtapa}
          setShow={setShowModalEtapa}
          currentEtapa={currentEtapa}
          currentDemanda={currentRow}
          setCurrentDemanda={setCurrentRow}
          cmbJuzgados={cmbJuzgados}
          cmbTipoJuicio={cmbTipoJuicio}
          loadInfoParent={reloadModal}
        />
      )}
      {showNuevaModalEtapa && (
        <ModalNuevaEtapa
          show={showNuevaModalEtapa}
          setShow={setShowNuevaModalEtapa}
          currentEtapa={currentEtapa}
          currentDemanda={currentRow}
          setCurrentDemanda={setCurrentRow}
          cmbJuzgados={cmbJuzgados}
          cmbTipoJuicio={cmbTipoJuicio}
          loadInfoParent={reloadModal}
        />
      )}
    </>
  );
};

export default ModalAdicion;
